const maxLength = 16;
const knownLengths = {
  us: 14,
  ca: 14,
  gb: 12,
};

export default countryCode => knownLengths[countryCode] || maxLength;
